export default __webpack_public_path__ + "static/media/ezdoc_logo_lg.243f48da.png";